import { loadFinding } from '@/api/finding'
import Finding from '@/store/models/Finding'

export default {

  namespaced: true,

  state: {
    finding: new Finding
  },

  mutations: {
    ...Finding.mutations()
  },

  actions: {
    loadFinding: ({commit}, findingId) => new Promise((resolve, reject) => loadFinding(findingId, ({data}) => {
      commit('setFinding', data)
      resolve()
    }, reject)),
  },

  getters: {
    finding: state => state.finding
  }
}